exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-design-tool-container[data-v-f978d9ca]{display:block}.insert-text[data-v-f978d9ca]{display:none}.disabled[data-v-f978d9ca]{opacity:.4}.element-custom.classification[data-v-f978d9ca]{margin-top:.175rem;color:var(--fts-default);font-size:85%}", ""]);

// exports
